import { useQuery } from '@tanstack/react-query';
import { GET_API_ROUTE } from 'src/constants/api';
import { appendDbEnv } from 'src/utils/dbApiEnv';
import { createQueryKey } from 'src/utils/query/createQueryKey';

interface PrivateBetaWalletWhitelistCheckResponse {
	data: {
		isWhitelisted: boolean;
	};
}

export async function fetchIsPrivateBetaWalletWhitelisted(
	authority: string
): Promise<boolean> {
	const response = await fetch(
		appendDbEnv(
			`${GET_API_ROUTE('private-beta-wallet-whitelist')}?authority=${encodeURIComponent(authority)}`
		)
	);

	if (!response.ok) {
		throw new Error('Failed to check private beta wallet whitelist status');
	}

	const json =
		(await response.json()) as PrivateBetaWalletWhitelistCheckResponse;
	return json.data.isWhitelisted;
}

export function useIsPrivateBetaWalletWhitelisted(
	authority: string | undefined,
	enabled = true
) {
	return useQuery({
		queryKey: createQueryKey('private-beta-wallet-whitelist', authority),
		queryFn: () => fetchIsPrivateBetaWalletWhitelisted(authority!),
		enabled: enabled && !!authority,
		staleTime: 60_000,
	});
}
